(function () {
  const EMPTY_BOX_ID = "#empty-search-container";

  const BOOST_INPUT_SELECTOR =
    'input[id^="boost-sd__search-widget-init-input"], input.boost-sd__search-widget-init-input, .search-modal input[type="search"], .search-modal__form input';

  const BOOST_DESKTOP_BOX = "#bc-instant-search";
  const BOOST_MOBILE_WRAPPER = "#boost-sd__search-bar-autocomplete-wrapper";
  const SEARCH_MODAL = ".search-modal";
  const SEARCH_MODAL_CONTENT = ".search-modal__content";
  const SEARCH_HISTORY_KEY = "skechers_search_history";
  const MAX_HISTORY_ITEMS = 5;
  const MAX_QUERY_LENGTH = 100;

  let lastFocusedBoostInput = null;
  let handleTimeout = null;
  let isHandling = false;
  let justFocused = false;

  // ========== SEARCH HISTORY FUNCTIONS ==========
  
  function sanitizeQuery(value) {
    if (typeof value !== 'string') return '';
    // Drop control characters, collapse whitespace, cap length.
    let out = '';
    for (const ch of value) {
      const code = ch.codePointAt(0);
      if (code < 32 || code === 127) continue;
      out += ch;
    }
    return out.replace(/\s+/g, ' ').trim().slice(0, MAX_QUERY_LENGTH);
  }

  function getSearchHistory() {
    try {
      const raw = localStorage.getItem(SEARCH_HISTORY_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      // Anything previously persisted could be malformed or attacker-supplied;
      // only keep well-formed string entries.
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(sanitizeQuery)
        .filter(Boolean)
        .slice(0, MAX_HISTORY_ITEMS);
    } catch (e) {
      console.error('[SearchHistory] Error reading history:', e);
      return [];
    }
  }

  function saveSearchQuery(query) {
    if (!query || query.trim().length < 2) {
      console.log('[SearchHistory] Query too short or empty:', query);
      return;
    }
    
    try {
      let history = getSearchHistory();
      const trimmedQuery = sanitizeQuery(query).toLowerCase();
      if (!trimmedQuery) return;

      // Remove if already exists
      history = history.filter(item => item.toLowerCase() !== trimmedQuery);
      
      // Add to beginning
      history.unshift(trimmedQuery);
      
      // Keep only last MAX_HISTORY_ITEMS
      history = history.slice(0, MAX_HISTORY_ITEMS);
      
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
      console.log('[SearchHistory] ✅ Saved:', trimmedQuery, 'Total history:', history);
    } catch (e) {
      console.error('[SearchHistory] ❌ Error saving:', e);
    }
  }
  
  // Expose function globally for testing
  window.saveSearchQuery = saveSearchQuery;
  window.getSearchHistory = getSearchHistory;

  function renderSearchHistory() {
    const historyContainer = document.querySelector('.empty-search-history-items');
    if (!historyContainer) return;
    
    const history = getSearchHistory();

    // Rebuild from DOM nodes rather than an HTML string: stored queries are
    // untrusted input and must never be parsed as markup.
    historyContainer.textContent = '';

    if (history.length === 0) {
      const empty = document.createElement('p');
      empty.style.color = 'rgba(var(--color-foreground), 0.6)';
      empty.style.fontSize = '14px';
      empty.textContent = 'No recent searches';
      historyContainer.appendChild(empty);
      return;
    }

    const fragment = document.createDocumentFragment();
    history.forEach(query => {
      const link = document.createElement('a');
      link.className = 'history-search-tag';
      link.setAttribute('href', '/search?q=' + encodeURIComponent(query));
      link.textContent = query;
      fragment.appendChild(link);
    });
    historyContainer.appendChild(fragment);
  }

  // ========== END SEARCH HISTORY FUNCTIONS ==========

  function removeDuplicateEmptySearch() {
  const all = document.querySelectorAll("#empty-search-container");
  if (all.length > 1) {
    // keep first, remove all extra
    all.forEach((el, index) => {
      if (index > 0) el.remove();
    });
  }
}
removeDuplicateEmptySearch();


  function debouncedHandle(delay = 50) {
    if (handleTimeout) clearTimeout(handleTimeout);
    handleTimeout = setTimeout(function() {
      if (isHandling) return;
      isHandling = true;
      handle();
      isHandling = false;
    }, delay);
  }

  function isElementVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return false;
    if (style.opacity === "0") return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isBoostInput(el) {
    return !!(el && el.matches && el.matches(BOOST_INPUT_SELECTOR));
  }

  function getVisibleBoostInputs() {
    const inputs = Array.from(document.querySelectorAll(BOOST_INPUT_SELECTOR));
    return inputs.filter((el) => isElementVisible(el));
  }

  function getActiveBoostInput() {
    // ✅ Prefer focused element (works for position:fixed inputs too)
    if (isBoostInput(document.activeElement)) return document.activeElement;

    // ✅ Prefer last focused Boost input if still in DOM
    if (lastFocusedBoostInput && document.contains(lastFocusedBoostInput)) return lastFocusedBoostInput;

    // ✅ Otherwise pick a visible one
    const visible = getVisibleBoostInputs();
    if (visible.length) return visible[0];

    // fallback
    const inputs = Array.from(document.querySelectorAll(BOOST_INPUT_SELECTOR));
    return inputs[0] || null;
  }

  function emptyBoxEl() {
    return document.querySelector(EMPTY_BOX_ID);
  }

  function boostDesktopBoxEl() {
    return document.querySelector(BOOST_DESKTOP_BOX);
  }

  function boostMobileWrapperEl() {
    return document.querySelector(BOOST_MOBILE_WRAPPER);
  }

  function searchModalEl() {
    return document.querySelector(SEARCH_MODAL);
  }

  function searchModalContentEl() {
    return document.querySelector(SEARCH_MODAL_CONTENT);
  }

  function isBoostSearchOpen() {
    const input = getActiveBoostInput();
    if (!input) return false;

    // ✅ If we just focused on a Boost input, treat as open (aria-expanded may not be updated yet)
    if (justFocused) return true;

    // ✅ Most reliable check for all layouts
    const expanded = input.getAttribute("aria-expanded");
    if (expanded === "true") return true;

    // ✅ If the input is focused, treat search as open (Boost may not update aria-expanded immediately)
    if (document.activeElement === input) return true;

    // ✅ fallback checks (prefer wrapper if present)
    const wrapper = boostMobileWrapperEl();
    if (isElementVisible(wrapper)) return true;

    const box = boostDesktopBoxEl();
    if (isElementVisible(box)) return true;

    // ✅ Check if search modal is open (tablet 1024px case)
    const modal = searchModalEl();
    if (modal && isElementVisible(modal)) {
      return true;
    }

    return false;
  }

  function moveEmptySearchIntoMobileWrapper() {
    const emptyBox = emptyBoxEl();
    if (!emptyBox) return;

    const wrapper = boostMobileWrapperEl();
    if (isElementVisible(wrapper) && !wrapper.querySelector("#empty-search-container")) {
      wrapper.prepend(emptyBox);
      return true;
    }

    // ✅ For tablet (1024px) - insert into search modal content
    const modal = searchModalEl();
    if (modal && isElementVisible(modal) && !modal.querySelector("#empty-search-container")) {
      // Try to find form inside modal
      const form = modal.querySelector("form");
      if (form) {
        form.insertAdjacentElement("afterend", emptyBox);
        return true;
      }
      // Fallback: append to modal content
      const modalContent = searchModalContentEl();
      if (modalContent) {
        modalContent.appendChild(emptyBox);
        return true;
      }
    }

    return false;
  }

  function clearFixedDropdownPositioning(emptyBox) {
    if (!emptyBox) return;
    emptyBox.style.position = "";
    emptyBox.style.top = "";
    emptyBox.style.left = "";
    emptyBox.style.width = "";
    emptyBox.style.maxWidth = "";
  }

  function positionEmptySearchUnderInput(emptyBox, input) {
    if (!emptyBox || !input) return;

    const rect = input.getBoundingClientRect();
    if (!rect || rect.width === 0 || rect.height === 0) return;

    if (emptyBox.parentElement !== document.body) {
      document.body.appendChild(emptyBox);
    }

    emptyBox.style.position = "fixed";
    emptyBox.style.top = `${Math.round(rect.bottom)}px`;
    emptyBox.style.left = "0";
    emptyBox.style.width = "100%";
    emptyBox.style.maxWidth = "100%";
  }

  function showEmptySearch() {
    const emptyBox = emptyBoxEl();
    const boostDesktopBox = boostDesktopBoxEl();
    if (!emptyBox) return;

    moveEmptySearchIntoMobileWrapper();

    const activeInput = getActiveBoostInput();
    if (!activeInput) return;

    const isInsideWrapper = !!emptyBox.closest(BOOST_MOBILE_WRAPPER);
    const isInsideModal = !!emptyBox.closest(SEARCH_MODAL);

    if (isInsideWrapper || isInsideModal) {
      clearFixedDropdownPositioning(emptyBox);
    } else {
      positionEmptySearchUnderInput(emptyBox, activeInput);
    }

    emptyBox.classList.remove("hidden");
    emptyBox.style.display = "flex";
    document.body.classList.add("empty-search-open");
    emptyBox.style.zIndex = "999999999";

    // Render dynamic search history
    renderSearchHistory();

    // Initialize slider with manual scroll implementation
    setTimeout(() => {
      const slider = emptyBox.querySelector('[id^="Slider-"]');
      const prevButton = emptyBox.querySelector('button[name="previous"]');
      const nextButton = emptyBox.querySelector('button[name="next"]');
      
      if (slider && prevButton && nextButton) {
        console.log('[EmptySearch] Setting up manual slider');
        
        // Calculate scroll amount (width of one item + gap)
        const getScrollAmount = () => {
          const firstItem = slider.querySelector('.grid__item');
          if (!firstItem) return slider.clientWidth;
          const itemWidth = firstItem.offsetWidth;
          const gap = 16; // 1.6rem gap
          return itemWidth + gap;
        };
        
        // Update button states
        const updateButtons = () => {
          const scrollLeft = slider.scrollLeft;
          const maxScroll = slider.scrollWidth - slider.clientWidth;
          
          if (scrollLeft <= 0) {
            prevButton.setAttribute('disabled', 'disabled');
          } else {
            prevButton.removeAttribute('disabled');
          }
          
          if (scrollLeft >= maxScroll - 5) {
            nextButton.setAttribute('disabled', 'disabled');
          } else {
            nextButton.removeAttribute('disabled');
          }
        };
        
        // Previous button click
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          const scrollAmount = getScrollAmount();
          slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          setTimeout(updateButtons, 300);
        });
        
        // Next button click
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          const scrollAmount = getScrollAmount();
          slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          setTimeout(updateButtons, 300);
        });
        
        // Update on scroll
        slider.addEventListener('scroll', updateButtons);
        
        // Initial update
        updateButtons();
        
        console.log('[EmptySearch] Manual slider initialized');
      }
    }, 200);

    // hide desktop boost suggestions only if exists
    if (boostDesktopBox && window.innerWidth > 991) {
      boostDesktopBox.style.opacity = "0";
    }
  }

  function hideEmptySearch() {
    const emptyBox = emptyBoxEl();
    const boostDesktopBox = boostDesktopBoxEl();
    if (!emptyBox) return;

    emptyBox.classList.add("hidden");
    emptyBox.style.display = "none";
    document.body.classList.remove("empty-search-open");

    if (boostDesktopBox) boostDesktopBox.style.opacity = "1";
  }

  function handle() {
    const input = getActiveBoostInput();
    if (!input) return;

    // ✅ Only work if search is really open
    if (!isBoostSearchOpen()) {
      hideEmptySearch();
      return;
    }

    // ✅ Show empty search only when query empty
    if (input.value.trim() === "") {
      showEmptySearch();
    } else {
      hideEmptySearch();
    }
  }

  // Always hide on load
  document.addEventListener("DOMContentLoaded", function () {
    hideEmptySearch();
  });

  // Show on focus
  document.addEventListener("focusin", function (e) {
    if (isBoostInput(e.target)) {
      lastFocusedBoostInput = e.target;
      justFocused = true;
      handle();
      setTimeout(function() { justFocused = false; }, 200);
    }
    removeDuplicateEmptySearch();
  });

  // Also handle click on Boost inputs (backup for 1024px modal case)
  document.addEventListener("click", function (e) {
    if (isBoostInput(e.target)) {
      lastFocusedBoostInput = e.target;
      justFocused = true;
      handle();
      setTimeout(function() { justFocused = false; }, 200);
    }
  });

  // Show/hide on typing
  document.addEventListener("input", function (e) {
    if (isBoostInput(e.target)) {
      lastFocusedBoostInput = e.target;
      debouncedHandle(30);
    }
  });

  // Click outside hides
  document.addEventListener("mousedown", function (e) {
    const emptyBox = emptyBoxEl();
    const activeInput = getActiveBoostInput();
    const boostDesktopBox = boostDesktopBoxEl();
    const boostMobile = boostMobileWrapperEl();

    if (!emptyBox || !activeInput) return;

    const clickedInsideInput = e.target === activeInput;
    const clickedInsideEmpty = e.target.closest(EMPTY_BOX_ID);
    const clickedInsideBoostDesktop = boostDesktopBox && e.target.closest(BOOST_DESKTOP_BOX);
    const clickedInsideBoostMobile = boostMobile && e.target.closest(BOOST_MOBILE_WRAPPER);
    const clickedInsideSearchModal = e.target.closest(SEARCH_MODAL);

    if (!clickedInsideInput && !clickedInsideEmpty && !clickedInsideBoostDesktop && !clickedInsideBoostMobile && !clickedInsideSearchModal) {
      hideEmptySearch();
    }
  });

  // Removed MutationObserver - was causing blinking due to Boost AI constantly updating DOM
  // Empty search now relies on focusin/input events which are sufficient
})();

// ✅ Prevent Boost from closing search when clicking inside empty-search
document.addEventListener(
  "mousedown",
  function (e) {
    if (e.target.closest("#empty-search-container")) {
      e.stopPropagation();
    }
  },
  true
);

// ✅ Keep focus on Boost input
document.addEventListener(
  "click",
  function (e) {
    if (e.target.closest("#empty-search-container")) {
      const activeInput = getActiveBoostInput();
      if (activeInput) activeInput.focus();
    }
  },
  true
);

// ========== CAPTURE SEARCH QUERIES ==========

// Capture when user clicks on Boost search results (product links, view all, etc.)
document.addEventListener('click', function(e) {
  const boostResultLink = e.target.closest('#bc-instant-search a, .boost-sd__search-bar-autocomplete-wrapper a, #boost-sd__search-bar-autocomplete-wrapper a');
  if (boostResultLink) {
    console.log('[SearchHistory] Boost result clicked');
    const input = document.querySelector('input[id^="boost-sd__search-widget-init-input"], input.boost-sd__search-widget-init-input, .search-modal input[type="search"]');
    if (input && input.value.trim()) {
      console.log('[SearchHistory] Capturing from Boost click:', input.value.trim());
      saveSearchQuery(input.value.trim());
    }
  }
}, true); // Use capture phase

// Capture when user submits search form
document.addEventListener('submit', function(e) {
  const searchForm = e.target.closest('form[action*="/search"]');
  if (searchForm) {
    console.log('[SearchHistory] Form submitted');
    const input = searchForm.querySelector('input[type="search"], input[name="q"]');
    if (input && input.value.trim()) {
      console.log('[SearchHistory] Capturing from form:', input.value.trim());
      saveSearchQuery(input.value.trim());
    }
  }
});

// Capture when user presses Enter in search input
document.addEventListener('keydown', function(e) {
  if (e.key === 'Enter') {
    const searchInput = e.target.closest('input[id^="boost-sd__search-widget-init-input"], input.boost-sd__search-widget-init-input, .search-modal input[type="search"], input[name="q"]');
    if (searchInput && searchInput.value.trim()) {
      console.log('[SearchHistory] Enter pressed in search:', searchInput.value.trim());
      saveSearchQuery(searchInput.value.trim());
    }
  }
});

// Capture from URL on search results page
if (window.location.pathname.includes('/search')) {
  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get('q');
  if (query && query.trim()) {
    console.log('[SearchHistory] Capturing from URL:', query.trim());
    saveSearchQuery(query.trim());
  }
}

// Additional: Monitor for navigation to search results (for Boost instant search)
let lastCapturedQuery = '';
setInterval(function() {
  if (window.location.pathname.includes('/search')) {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    if (query && query.trim() && query !== lastCapturedQuery) {
      console.log('[SearchHistory] Detected new search in URL:', query.trim());
      saveSearchQuery(query.trim());
      lastCapturedQuery = query;
    }
  }
}, 1000);

// fixed position 
(function () {

  function setEmptySearchTop() {

    if (window.innerWidth <= 990) return; // ✅ only desktop

    const headerSection =
      document.querySelector('.shopify-section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('.section-header') ||
      document.querySelector('header');

    const search = document.querySelector('#empty-search-container');

    if (!headerSection || !search) return;

    const rect = headerSection.getBoundingClientRect();

    search.style.top = rect.bottom + "px";

  }

  document.addEventListener("DOMContentLoaded", setEmptySearchTop);

  window.addEventListener("scroll", setEmptySearchTop);
  window.addEventListener("resize", setEmptySearchTop);

  const observer = new MutationObserver(() => {

    if (window.innerWidth > 990) {
      setEmptySearchTop();
    }

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });

})();

// suggestion search- fixed position

(function () {

  function positionBoostSearch() {

    if (window.innerWidth <= 990) return;

    const header =
      document.querySelector('.header-wrapper') ||
      document.querySelector('.shopify-section-header') ||
      document.querySelector('header');

    const searchInput =
      document.querySelector('.boost-sd__search-bar-input') ||
      document.querySelector('input[type="search"]');

    const wrapper =
      document.querySelector('#boost-sd__search-widget-init-wrapper');

    if (!header || !searchInput || !wrapper) return;

    const headerRect = header.getBoundingClientRect();
    const inputRect = searchInput.getBoundingClientRect();

    /* ---------- TOP (below header) ---------- */

    wrapper.style.top =
      headerRect.bottom + window.scrollY + "px";

    /* ---------- LEFT align with search ---------- */

    wrapper.style.left =
      inputRect.left + window.scrollX + "px";

    /* ---------- WIDTH full container ---------- */

    wrapper.style.width =
      window.innerWidth - inputRect.left + "px";

    wrapper.style.right = "auto";

    wrapper.style.position = "absolute";

    wrapper.style.zIndex = "999999";

  }


  function init() {
    positionBoostSearch();

    window.addEventListener("resize", positionBoostSearch);
    window.addEventListener("scroll", positionBoostSearch);

    const observer = new MutationObserver(() => {
      positionBoostSearch();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("DOMContentLoaded", init);

})();